import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SpotlightButton from './SpotlightButton'
import { State } from '../../dataStore/reducers/reducerType'
import { openSpotlightMediaDrawer, closeSpotlightMediaDrawer } from '../../dataStore/actions/ui/uiActions'
import constants, { mediaType as MediaType } from '@bt-react/constants'
import getPresentersFromSeatingOrder from '../../dataStore/selectors/getPresentersFromSeatingOrder'

const SpotlightButtonIndex: React.FunctionComponent = (props) => {
  const isActive = useSelector((state: State) => state.ui.selectedDrawer === constants.drawerType.SPOTLIGHT || state.room.mediaType === MediaType.SPOTLIGHT) as boolean
  const mediaDrawerOpen = useSelector((state: State) => state.ui.selectedDrawer === constants.drawerType.SPOTLIGHT) as boolean
  const presenterCountFromSeatingOrder = useSelector((state: State) => getPresentersFromSeatingOrder(state).length) as number
  const dispatch = useDispatch()

  const toggleOpenSpotlightMediaDrawer = () => dispatch(openSpotlightMediaDrawer())
  const toggleCloseSpotlightMediaDrawer = () => dispatch(closeSpotlightMediaDrawer())

  return <SpotlightButton
          {...props}
          isActive={isActive}
          mediaDrawerOpen={mediaDrawerOpen}
          openMediaDrawer={toggleOpenSpotlightMediaDrawer}
          closeMediaDrawer={toggleCloseSpotlightMediaDrawer}
          presenterCount={presenterCountFromSeatingOrder}
        />
}

export default SpotlightButtonIndex

